import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsReactrouterComponent } from './simple-icons-reactrouter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsReactrouterComponent ],
    exports:      [ SimpleIconsReactrouterComponent ],
    bootstrap:    []
})
export class SimpleIconsReactrouterModule {}
